module.exports = __webpack_public_path__ + "static/media/laurea-logo.en.bd1a403f.png";